<div class="chatMessage_container">
  <div class="chatMessage_messageContent" [ngClass]="[ isUserMessage ? 'user' : 'server', isMobileView ? 'is-mobile-view' : '' ]">
    @if (messageText == ""){
    <span class="chatMessage_text" [ngClass]="[ isUserMessage ? 'user' : 'server', isMobileView ? 'is-mobile-view' : '' ]">...</span>
    } @else{
    <span class="chatMessage_text" [ngClass]="[ isUserMessage ? 'user' : 'server', isMobileView ? 'is-mobile-view' : '' ]" [innerHtml]="messageText"></span>
    }
  </div>
  @if (!isUserMessage && !isLiveMessage && messageText != ""){
  <div class="chatMessage_messageActions">
    <button mat-icon-button (click)="copyMessage()" [matTooltip]="copied ? 'Copied!' : 'Copy'" matTooltipPosition="above">
      <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
    </button>
    @if (!isB2C){
    <button mat-icon-button (click)="messageLiked()" [ngClass]="{ chatMessage_highlightSentiment: userRating == chatMessageRatingEnum.LIKED }">
      <mat-icon>thumb_up</mat-icon>
    </button>
    <button mat-icon-button (click)="messageDisliked()" [ngClass]="{ chatMessage_highlightSentiment: userRating == chatMessageRatingEnum.DISLIKED }">
      <mat-icon>thumb_down</mat-icon>
    </button>
    }
  </div>
  }
</div>